import { gql } from '@apollo/client'

export const PLAYLIST_QUERY = gql`
query PlaylistById($id: String!){
	nodeById(id: $id) {
		... on NodePlaylist {
			uuid
			entityChanged
			nid
			title
			fieldPlaylistDescription
			fieldPlaylistItemsCount
			entityType
			isLikedByCurrentUser
			fieldPlaylistImportedFromSap
			fieldPlaylistTabs {
				entity {
					... on LayoutTab {
						title		
                        id
                        uuid
						fieldTabItems {
							entity {
								entityType

								... on NodeResource {
								    uuid
								    fieldResourceTags{
                                        entity{
                                    entityLabel
                                        }
                                    }
									entityChanged
									entityCreated
									nid
									title
									entityId
									entityLabel
									entityType
									fieldResourceDescription
									fieldResourceFromDate
                  fieldResourceReleaseDate
									isLikedByCurrentUser
                                    fieldResourceOfflinePeriod {
                                        targetId
                                    }  
									fieldResourceFilesByFormat {
										entity {
											... on Media {
											    uuid
											    entityChanged
											    entityCreated
												name
												mid
												entityLabel
												entityType
												entityBundle
												entityId
												uuid
												bundle {
													targetId
												}
											}

											... on MediaMediaFile {
												fieldMediaFileLanguage {
													value
												}

												fieldMediaFile {
													entity {
														... on File {
														    uuid
															entityChanged
															entityCreated
															entityId
															url
															filesize
															filemime
															filename
														}
													}
												}
											}
											... on MediaSapFile {
											    uuid
												entityChanged
												entityId
												fieldSapFromDate
												fieldSapReleaseDate
												fieldSapFileLanguage {
													value
												}
												fieldSapFileFileSize
												fieldSapFileFileName
												fieldSapFileDocumentVersion
												fieldSapFileMime
												fieldSapFileFileExtension {
													entity {
														... on TaxonomyTermFileExtension {
															fieldFileExtensionValue
														}
													}
												}
											}
											... on MediaMasterControl {
											   uuid
											   entityChanged
                         entityId
                         fieldMasterControlId
                         fieldMasterControlCategory
                         fieldMasterControlDescription
                         fieldMasterControlTitle
                         fieldMasterControlRevision
                         fieldMasterControlMime
                         fieldMasterControlSize
                         fieldMasterControlExtension {
													entity {
														... on TaxonomyTermFileExtension {
															fieldFileExtensionValue
														}
													}
												 }
                      }
                      ... on MediaMasterControlAttachment {
											   uuid
											   entityChanged
                         entityId
                         fieldMcAttachmentId
                         fieldMcAttachmentName
                         fieldMcAttachmentDescription
                         fieldMcAttachmentMime
                         fieldMcAttachmentSize
                         fieldMcAttachmentExtension {
													entity {
														... on TaxonomyTermFileExtension {
															fieldFileExtensionValue
														}
													}
												 }
                      }
											... on MediaBokeccVideo {
												fieldBokeccIframe
											}
											       ... on MediaExternalLink{
                                                    fieldExternalLinkLink{
                                                      url {
                                                        path
                                                      }
                                                    }
                                                  }
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
}
`
;
